import { MostSearchedResult } from '@/types/most-search-type';
import { CheckboxProcedure } from '@/app/(main)/_components/search-modal/_components/checkbox-procedure.component';
import { LaboratoryProcedureLoading } from '@/app/(main)/_components/search-modal/_components/loadings/laboratory-procedure-loading.component';
import { SearchResult, SelectedProcedures } from '@/app/(main)/_components/search-modal/search-modal.types';

export interface SelectMoreResultsProps {
  isLoading?: boolean;
  searchResults?: SearchResult[];
  mostSearchedProcedures: MostSearchedResult[];
  isChecked: (procedure: MostSearchedResult | SearchResult | SelectedProcedures) => boolean;
  handleSelectProcedure: (procedure: MostSearchedResult | SearchResult | SelectedProcedures) => void;
}

export function SelectMoreResults({
  isLoading,
  searchResults,
  mostSearchedProcedures,
  handleSelectProcedure,
  isChecked,
}: SelectMoreResultsProps) {
  if (isLoading) {
    return <LaboratoryProcedureLoading />;
  }

  const procedures = searchResults?.length ? searchResults : mostSearchedProcedures;

  return (
    <>
      {procedures.map((procedure) => (
        <CheckboxProcedure
          key={procedure.id || procedure.code}
          procedure={procedure}
          handleSelectProcedure={handleSelectProcedure}
          isChecked={isChecked}
        />
      ))}
    </>
  );
}
